import { useEffect, useState } from 'react';

/**
 * Check meta tag for customize showcase controls, if
 * <meta name="customize-showcase-controls" content="1" /> exists in head, hasCustomizeShowcaseControls will be true
 * TODO: remove this hook after showcase customize controls is fully rolled out
 */
export const useCustomizeControls = () => {
  const [hasCustomizeShowcaseControls, setHasCustomizeShowcaseControls] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    const releaseMetaTag = document.querySelector('meta[name="customize-showcase-controls"]');

    if (releaseMetaTag?.getAttribute('content') === '1') {
      setHasCustomizeShowcaseControls(true);
    } else {
      setHasCustomizeShowcaseControls(false);
    }
  }, []);

  return { hasCustomizeShowcaseControls };
};
